import React from 'react';
import Layout from "../components/App/Layout"
import SEO from "../components/App/SEO"
import NavbarStyleTwo from '../components/App/NavbarStyleTwo';
import PageBanner from '../components/Common/PageBanner';
import Footer from '../components/App/Footer';
import StartProjectWithUs from '../components/Common/StartProjectWithUs';
import { Link } from "gatsby"

import CXServicesImg1 from '../assets/images/retail-and-ecommerce-ai/1.png'
import CXServicesImg2 from '../assets/images/retail-and-ecommerce-ai/2.png'
import CXServicesImg3 from '../assets/images/retail-and-ecommerce-ai/3.png'
import CXServicesImg4 from '../assets/images/retail-and-ecommerce-ai/4.png'
import CXServicesImg5 from '../assets/images/retail-and-ecommerce-ai/5.png'


const SingleServices = () => {
    return (
        <Layout>
            <SEO title="Retail & eCommerce AI" description="Delivering a frictionless customer experience is key to building meaningful relationships and driving sales. With AI, it's possible to deliver this frictionless customer experience across all the physical and digital touchpoints. By using AI, customers can be sure they are getting the best experience possible, and companies can be sure they are providing the most efficient and effective customer service."/>

			<NavbarStyleTwo />

			<PageBanner 
                pageTitle="Retail & eCommerce AI" 
            /> 

<div className="overview-area ptb-100">
                <div className="container">
                    <div className="overview-box">
                        <div className="overview-content">
                            <div className="content">
                                <span className="sub-title">Craft Engaging Experiences</span>
                                <h2>Craft meaningful customer experiences that drive engagement & RoI</h2>
                                <p>Delivering a frictionless customer experience is key to building meaningful relationships and driving sales. With AI, it's possible to deliver this frictionless customer experience across all the physical and digital touchpoints. By using AI, customers can be sure they are getting the best experience possible, and companies can be sure they are providing the most efficient and effective customer service.</p>
                                <div className="features-text">
                                    <h4>According to a survey by Deloitte, 68% of retailers are investing in artificial intelligence to improve customer experience</h4>
                  
                                </div>
               
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg1} alt="Cimplify Retail & eCommerce AI" />
                            </div>
                        </div>
                    </div>
                    <div className="services-area bg-f9f9f9 pt-100 pb-70">
                <div className="container">
                    <div className="section-title">
                        <span className="sub-title">DRIVE DIGITAL TRANSFORMATION</span>
                        <h2>Core Solutions</h2>
                        {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p> */}
                    </div>

                    <div className="row d-flex justify-content-center text-center">
                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/retail-and-ecommerce-ai#in-store-traffic-analytics">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-store"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>In-Store Traffic Analytics</h3>
                                <p>Monitor foot traffic and customer behaviour inside the store using AI-powered computer vision models</p>
                            </div>
                            </Link>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/retail-and-ecommerce-ai#ai-powered-conversations">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-conversation"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>AI-Powered Conversations</h3>
                                <p>Design and deploy engaging conversational experiences, everywhere and anywhere customers meet your brand.</p>
                            </div>
                        </Link>
                        </div>

                    </div>
                    <div className="row d-flex justify-content-center text-center">
                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/retail-and-ecommerce-ai#assisted-shopping">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-cart-alt"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Assisted Shopping </h3>
                                <p>Help customer make the right choice with AI-powered shopping assistance and immersive experiences.</p>
                            </div>
                        </Link>    
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6" align = "center">
                        <Link to="/retail-and-ecommerce-ai#immersive-experiences">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-glasses-alt"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Immersive Experiences</h3>
                                <p>Use AR/VR to empower the customer in the pre-decision making process and drive conversions.</p>
                            </div>
                        </Link>    
                        </div>

                    
                    </div>
                </div>
            </div>
                    <div id="in-store-traffic-analytics" className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg2} alt="Cimplify In-Store Traffic Analytics" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">UNLOCK THE POWER OF AI</span>
                                <h2>In-Store Traffic Analytics</h2>
                                <p>Track customer movements and activity inside the store to measure customer engagement, conversion rates, and other metrics. This will help optimize the store layout and improve customer experience. Artificial intelligence can also be used to track customer demographics, such as age and gender, to better understand customer behaviour.</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> In-store Customer Journey Maps </span></li>
                                    <li><span><i className='bx bx-check'></i> Customer Dwell Time Analysis</span></li>
                                    <li><span><i className='bx bx-check'></i> Demographic Analysis</span></li>
                                    <li><span><i className='bx bx-check'></i> Heatmaps for Store Layout Planning</span></li>
                                    <li><span><i className='bx bx-check'></i> Workforce Planning</span></li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                     <div id="ai-powered-conversations" className="overview-box">
                       
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">PROVIDE 24X7 SUPPORT ACROSS CHANNELS</span>
                                <h2>AI-Powered Conversations </h2>
                                <p>Design and deploy engaging conversational experiences, everywhere and anywhere customers meet your brand. Deliver a personalized experience to the customer in a medium of their choice and in the language of their choice.</p>
                                <ul className="features-list">
                                <li><span><i className='bx bx-check'></i> Intelligent Virtual Assistants </span></li>
                                    <li><span><i className='bx bx-check'></i> Contextual Chatbots</span></li>
                                    <li><span><i className='bx bx-check'></i>Natural Language Understanding Engine</span></li>
                                    <li><span><i className='bx bx-check'></i> Multiple Language Support</span></li>
                                    <li><span><i className='bx bx-check'></i> Omnichannel Orchestration</span></li>
                                    <li><span><i className='bx bx-check'></i> Human-in-the-Loop for handoff</span></li>
                                    <li><span><i className='bx bx-check'></i> Conversation Analytics</span></li>
                                    <li><span><i className='bx bx-check'></i> Webhooks & API Integration</span></li>
                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg3} alt="Cimplify Hyper-personalization" />
                            </div>
                        </div>
                    </div>
                    <div id="assisted-shopping" className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg4} alt="Cimplify Assisted Shopping" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">Drive Conversions</span>
                                <h2>Assisted Shopping</h2>
                                <p>Be it online or offline, customers need support and guidance to make an informed decision. Help customer make the right choice with AI-powered shopping assistance and immersive experiences. </p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Refined Product Recommendations</span></li>
                                    <li><span><i className='bx bx-check'></i> Virtual Try-on </span></li>
                                    <li><span><i className='bx bx-check'></i> Assisted Order Placement </span></li>
                                    <li><span><i className='bx bx-check'></i> Conversational Cross-Selling & Up-Selling</span></li>
                                    <li><span><i className='bx bx-check'></i> Order Tracking Chatbots</span></li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                     <div id="immersive-experiences" className="overview-box">
                       
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">Craft Engaging Experiences</span>
                                <h2>Immersive Experiences</h2>
                                <p>Design AR/VR experiences that empower the customer during the pre-decision making process. Create engaging content that let's the customer experience the product virtually before making the purchase.</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Virtual Try-on for Online Shopping</span></li>
                                    <li><span><i className='bx bx-check'></i> 3D Product Visualization</span></li>
                                    <li><span><i className='bx bx-check'></i> AR/VR Product Discovery </span></li>
                                    <li><span><i className='bx bx-check'></i> Virtual Walkthroughs</span></li>
                                    <li><span><i className='bx bx-check'></i> Social Media AR Filters</span></li>
 
                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={CXServicesImg5} alt="Cimplify Immersive Experiences" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          



            

            <StartProjectWithUs />
			  
			<Footer />
		</Layout>
    )
}

export default SingleServices;